export enum CostCalculationMethods {
    Average,
    FIFO
}